import React from 'react';
import {
    RaceIndicatorIcon,
    RaceIndicatorLabel,
    RaceIndicatorWrapper,
} from 'src/domains/sportsbook/webview/components/raceIndicator/RaceIdicator.style';
import type { RaceIndicatorVariant } from 'src/domains/sportsbook/webview/components/raceIndicator/RaceIdicator.style';

interface RaceIndicatorPropsType {
    children?: React.ReactNode;
    className?: string;
    label: React.ReactNode;
    size: 'small' | 'medium';
    variant: RaceIndicatorVariant;
    dataTest?: string;
}

export const RaceIndicator = ({
    children,
    className,
    label,
    size,
    variant,
    dataTest,
}: RaceIndicatorPropsType): JSX.Element => (
    <RaceIndicatorWrapper
        className={className}
        data-test={dataTest}
        size={size}
        variant={variant}
    >
        {children === undefined ? null : <RaceIndicatorIcon>{children}</RaceIndicatorIcon>}
        <RaceIndicatorLabel>{label}</RaceIndicatorLabel>
    </RaceIndicatorWrapper>
);
